import React, { ReactNode, useMemo, useState } from 'react';

import ExerciseItem from '../exercise-item/ExerciseItem';
import Search from '../../../../components/reusable/search/Search';
import { useStyles } from './ExcerciseList.styles';
import theme from '../../../../styles/theme';
import { IExercise } from '../../../../types/interfaces/exercise';

const ExerciseList = (props: {
  exercises: IExercise[];
  showSearch?: boolean;
  showTranslationsError?: boolean;
  showPublicStatus?: boolean;
  getActionButtons?: (exercise: IExercise) => ReactNode[] | ReactNode;
  onExerciseClick?: (exercise: IExercise) => void;
}) => {
  const {
    exercises,
    showSearch = true,
    getActionButtons,
    showTranslationsError = false,
    showPublicStatus = false,
    onExerciseClick,
  } = props;
  const [filter, setFilter] = useState('');
  const { classes } = useStyles(theme);

  const filteredExercises = useMemo(
    () =>
      exercises?.filter(
        (exercise) => exercise.title.toLowerCase().indexOf(filter) !== -1,
      ),
    [filter, exercises],
  );

  return (
    <div className={classes.exerciseList}>
      {showSearch && (
        <Search
          fullWidth
          value={filter}
          onChange={setFilter}
          className={classes.exerciseListSearch}
        />
      )}
      {filteredExercises?.map((exercise) => (
        <React.Fragment key={exercise.id}>
          <ExerciseItem
            exercise={exercise}
            getActionButtons={getActionButtons}
            showTranslationsError={showTranslationsError}
            showPublicStatus={showPublicStatus}
            onExerciseClick={onExerciseClick}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

export default ExerciseList;
